import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "wcgk32-0"
})(["margin-top:0.8rem;&:not(:nth-child(7n)){padding-right:0.8rem;}font-size:", ";color:", ";", " ", " ", " ", " ", " cursor:pointer;"], function (_ref) {
  var fonts = _ref.theme.fonts;
  return fonts.size.medium;
}, function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.darkBlue;
}, function (_ref3) {
  var displayOnlyInMonth = _ref3.displayOnlyInMonth,
      shadowed = _ref3.shadowed;
  return displayOnlyInMonth && shadowed && css(["visibility:hidden;"]);
}, function (_ref4) {
  var shadowed = _ref4.shadowed,
      isInPath = _ref4.isInPath;
  return !shadowed && isInPath && css(["background:", ";"], function (_ref5) {
    var palette = _ref5.theme.palette;
    return transparentize(0.86, palette.primary["default"]);
  });
}, function (_ref6) {
  var shadowed = _ref6.shadowed,
      isInPath = _ref6.isInPath,
      isSelected = _ref6.isSelected,
      isStartEdge = _ref6.isStartEdge,
      isEndEdge = _ref6.isEndEdge;
  return shadowed && (isInPath || isSelected || isStartEdge || isEndEdge) && css(["background:", ";"], function (_ref7) {
    var palette = _ref7.theme.palette;
    return transparentize(0.66, palette.lightGrey);
  });
}, function (_ref8) {
  var isStartEdge = _ref8.isStartEdge,
      isSelected = _ref8.isSelected;
  return (isStartEdge || isSelected) && css(["border-top-left-radius:2.8rem;border-bottom-left-radius:2.8rem;"]);
}, function (_ref9) {
  var isEndEdge = _ref9.isEndEdge,
      isSelected = _ref9.isSelected;
  return (isEndEdge || isSelected) && css(["border-top-right-radius:2.8rem;border-bottom-right-radius:2.8rem;&:not(:nth-child(7n)){padding-right:0;margin-right:0.8rem;}"]);
});
export var Content = styled.div.withConfig({
  displayName: "elements__Content",
  componentId: "wcgk32-1"
})(["display:flex;justify-content:center;align-items:center;flex-basis:2.8rem;width:2.8rem;height:2.8rem;max-width:2.8rem;border-radius:2.8rem;user-select:none;&:hover{background:", ";}&,&:hover{", ";", ";", " ", ";}", ";", ";"], function (_ref10) {
  var palette = _ref10.theme.palette;
  return transparentize(0.86, palette.primary["default"]);
}, function (_ref11) {
  var shadowed = _ref11.shadowed;
  return shadowed && css(["background:transparent;color:", ";"], function (_ref12) {
    var palette = _ref12.theme.palette;
    return palette.mediumGrey;
  });
}, function (_ref13) {
  var disabled = _ref13.disabled;
  return disabled && css(["cursor:not-allowed;background:transparent;color:", ";"], function (_ref14) {
    var palette = _ref14.theme.palette;
    return palette.lightGrey;
  });
}, function (_ref15) {
  var isInPath = _ref15.isInPath,
      isStartEdge = _ref15.isStartEdge,
      isEndEdge = _ref15.isEndEdge;
  return isInPath && !isStartEdge && !isEndEdge && css(["background:", ";"], function (_ref16) {
    var palette = _ref16.theme.palette;
    return transparentize(0.86, palette.primary["default"]);
  });
}, function (_ref17) {
  var isSelected = _ref17.isSelected,
      shadowed = _ref17.shadowed,
      isStartEdge = _ref17.isStartEdge,
      isEndEdge = _ref17.isEndEdge;
  return !shadowed && (isSelected || isStartEdge || isEndEdge) && css(["color:", ";background:", ";"], function (_ref18) {
    var palette = _ref18.theme.palette;
    return palette.white;
  }, function (_ref19) {
    var palette = _ref19.theme.palette;
    return palette.primary["default"];
  });
}, function (_ref20) {
  var isStartEdge = _ref20.isStartEdge,
      isEndEdge = _ref20.isEndEdge;
  return isStartEdge && !isEndEdge && css(["border-top-right-radius:0;border-bottom-right-radius:0;"]);
}, function (_ref21) {
  var isStartEdge = _ref21.isStartEdge,
      isEndEdge = _ref21.isEndEdge;
  return isEndEdge && !isStartEdge && css(["border-top-left-radius:0;border-bottom-left-radius:0;"]);
});